import MainCourseList from "./index.vue";
import CourseList from "./list.vue";
import SceneList from "./sceneList.vue";
import UpdateRecord from "./updateRecord/updateRecord.vue";

export default {
  path: "courseList",
  name: "MainCourseList",
  component: MainCourseList,
  redirect: "courseList/list",
  meta: {
    label: "课中管理",
  },
  children: [
    {
      name: "CourseTable",
      path: "list",
      component: CourseList,
      meta: {
        label: "课中列表",
      },
    children: [
        {
          name: "UpdateRecord",
          path: "record",
          component: UpdateRecord,
          meta: {
            label: "更新记录",
          },
        },
      ],
    },
    {
      name: "SceneList",
      path: "scene",
      component: SceneList,
      meta: {
        label: "场景列表",
      },
    },
  ],
};
